import { capitalizeString } from './capitalize-string';
export const nameToToken = (str) => {
    return str.split('-').join('_').toUpperCase();
};
export const tokenToName = (str) => {
    return str.split('_').join('-').toLowerCase();
};
export const tokenToCamelCaseName = (str) => {
    return str
        .split('_')
        .map((str) => capitalizeString(str.toLowerCase()))
        .join('');
};
